// extracted by mini-css-extract-plugin
export default {"gazeTrace":"gaze-trace_gazeTrace__6b4oG","inverted":"gaze-trace_inverted__YddxL"};